module.exports = __webpack_public_path__ + "img/festival_luckycat.43a28a10.png";